import type { ReactElement } from 'react';

export default function Logo(): ReactElement {
  return (
    <div className="w-fit flex items-center justify-center gap-2">
      <div className="w-fit flex flex-col items-center justify-center text-center sm:justify-start sm:items-start sm:text-left gap-1">
        <p className="w-fit font-bold text-xl leading-none">KILOWATTCOIN</p>
      </div>
    </div>
  );
}
